export const MODAL_OPEN_REQUEST = 'MODAL_OPEN_REQUEST';
export const MODAL_CLOSE_REQUEST = 'MODAL_CLOSE_REQUEST';
